import { render } from "./SelecaoDeDedoTeste.vue?vue&type=template&id=08dca330&scoped=true"
import script from "./SelecaoDeDedoTeste.vue?vue&type=script&lang=js"
export * from "./SelecaoDeDedoTeste.vue?vue&type=script&lang=js"

import "./SelecaoDeDedoTeste.vue?vue&type=style&index=0&id=08dca330&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08dca330"]])

export default __exports__